import { inject, Injectable } from '@angular/core';
import { FlyoutToday } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  AuxiliaryNavigationAemItem,
  DashboardResponse,
  HeaderFooterMachCoreContentService,
  TodayPanelAem,
  UserSessionService
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { BehaviorSubject, forkJoin, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { FlyoutTodayAdapterService } from '../../adapters/today/flyout-today-adapter.service';
import { TodaysTripService } from '../../services/todays-trips/todays-trip.service';

@Injectable({
  providedIn: 'root'
})
export class FlyoutTodayFacadeService {
  adapter = inject(FlyoutTodayAdapterService);
  userSession = inject(UserSessionService);
  todayTrips = inject(TodaysTripService);
  headerFooterContent = inject(HeaderFooterMachCoreContentService);
  flyoutTodayDetails$ = new BehaviorSubject<FlyoutToday>({} as FlyoutToday);

  init(): void {
    if (this.flyoutTodayDetails$.getValue().todayTrip?.firstName) {
      return;
    } else {
      this.userSession
        .getUserSession()
        .pipe(
          switchMap((dashboardResponse: DashboardResponse) => {
            return forkJoin([
              of(dashboardResponse),
              this.todayTrips
                .getTodayTrip(dashboardResponse.smNumber)
                .pipe(take(1)),
              this.headerFooterContent
                .getHeaderFooterMachCoreContent$()
                .pipe(take(1))
            ]);
          })
        )
        .subscribe(([dashboardResponse, todayTrip, contentHeaderFooter]) => {
          const todayPanelData =
            contentHeaderFooter?.header?.auxiliaryNavigation?.find(
              (item: AuxiliaryNavigationAemItem) => item.id === 'todayPanel'
            ) as TodayPanelAem;
          const errorMessages = {
            errormessages: todayPanelData?.errormessages || []
          };
          this.flyoutTodayDetails$.next(
            this.adapter.getContent(
              dashboardResponse,
              todayTrip,
              errorMessages,
              contentHeaderFooter
            )
          );
        });
    }
  }
}
